import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Car, ArrowLeft } from "lucide-react";

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-[#000091] text-white">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
              <Car className="w-6 h-6 text-[#000091]" />
            </div>
            <h1 className="text-2xl font-bold">Mentions Légales</h1>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <Card className="border-slate-200">
          <CardContent className="p-8 prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">1. Éditeur du site</h2>
              <p className="text-slate-600">
                Le site Carte Grise Étrangère est édité par :<br />
                <strong>Moteur and Co</strong><br />
                Siège social : 6 rue d'Armaillé, 75017 Paris<br />
                SIRET : 890 446 990 00016<br />
                N° TVA intracommunautaire : FR 89 890446990
              </p>
              <p className="text-slate-600 mt-4">
                <strong>Directeur de la publication :</strong> Le gérant de Moteur and Co<br />
                <strong>Contact :</strong> contact@cartegrise-etrangere.fr
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">2. Hébergeur</h2>
              <p className="text-slate-600">
                Le site est hébergé par :<br />
                <strong>Emergent AGI, Inc.</strong><br />
                États-Unis
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">3. Activité</h2>
              <p className="text-slate-600">
                Carte Grise Étrangère est un service en ligne dédié aux démarches d'immatriculation 
                de véhicules importés de l'Union Européenne.
              </p>
              <p className="text-slate-600 mt-4">
                Notre activité principale consiste à accompagner les particuliers et professionnels dans 
                l'immatriculation de véhicules importés de l'Union Européenne.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">4. Propriété intellectuelle</h2>
              <p className="text-slate-600">
                L'ensemble du contenu de ce site (textes, images, logos, icônes, sons, logiciels) est 
                la propriété exclusive de Moteur and Co ou de ses partenaires et est protégé par 
                les lois françaises et internationales relatives à la propriété intellectuelle.
              </p>
              <p className="text-slate-600 mt-4">
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie 
                des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf 
                autorisation écrite préalable de Moteur and Co.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">5. Responsabilité</h2>
              <p className="text-slate-600">
                Moteur and Co s'efforce d'assurer au mieux l'exactitude et la mise à jour des 
                informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout 
                moment et sans préavis, le contenu.
              </p>
              <p className="text-slate-600 mt-4">
                Toutefois, Moteur and Co ne peut garantir l'exactitude, la précision ou l'exhaustivité 
                des informations mises à disposition sur ce site. En conséquence, Moteur and Co 
                décline toute responsabilité pour les éventuelles imprécisions, inexactitudes ou omissions 
                portant sur des informations disponibles sur ce site.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">6. Données personnelles</h2>
              <p className="text-slate-600">
                Les informations recueillies sur ce site font l'objet d'un traitement informatique destiné 
                à la gestion des demandes d'immatriculation. Pour plus d'informations sur le traitement de 
                vos données personnelles, veuillez consulter notre{" "}
                <Link to="/confidentialite" className="text-[#000091] hover:underline">
                  Politique de Confidentialité
                </Link>.
              </p>
              <p className="text-slate-600 mt-4">
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi 
                « Informatique et Libertés », vous disposez d'un droit d'accès, de rectification, de 
                suppression et d'opposition aux données vous concernant.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">7. Cookies</h2>
              <p className="text-slate-600">
                Ce site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des 
                statistiques de visites. En poursuivant votre navigation sur ce site, vous acceptez 
                l'utilisation de cookies. Vous pouvez modifier les paramètres de votre navigateur pour 
                refuser les cookies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-[#000091] mb-4">8. Droit applicable</h2>
              <p className="text-slate-600">
                Les présentes mentions légales sont régies par le droit français. En cas de litige, 
                les tribunaux français seront seuls compétents.
              </p>
            </section>

            <div className="bg-slate-100 rounded-lg p-4 mt-8">
              <p className="text-sm text-slate-500">
                Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
              </p>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default MentionsLegalesPage;
